module.exports = __webpack_public_path__ + "img/title4.0bdf83c5.png";